import { makeAutoObservable, toJS } from "mobx"
import { ACTIVITY_STATES } from "./MeetingsApi"
import { Meeting } from "./Meeting"

/**
 * Permet de modeliser une Activity serveur, et d'observer certaines de ses propriétés afin de l'utiliser dans l'UI
 */
export class Activity {
  Name
  NetID

  CompletionTime

  TimeElapsed = 0 // a virer
  ClosingIn // a virer

  /** @type {number} durée depuis laquelle l'activity est accessible par ce joueur */
  TimeOpened = 0 // en ms

  /** @type {number} durée depuis laquelle le joueur est entré dans l'activity */
  TimeEntered = 0 // en ms

  /** @type {number} durée avant que l'activity se ferme pour le joueur */
  TimeLeft = 0 // en ms
  ScheduledOpeningTime
  ScheduledClosingTime
  Observers
  PlayersEntered
  OpenStartTime
  CompleteTime
  Duration

  /** @type {Object.<string, import("./Meeting").MeetingPlayer>} */
  Players = {}
  Enabled
  Opened
  Type
  DataRef
  InitData = {}
  SequencerAutoOpenNext=null

  /** @type {Activity}*/
  Parent = null

  /** @type {Array<Activity>}*/
  Children = null

  Synchro = null
  PlayersAuthorized = null
  PlayersWhoCompleted = null
  PlayersContext = null

  /** @type {import("./Meeting").SequencerModes} */
  SequencerSubMode = null

  /** @type {Meeting} */
  meetingRef = null
  getJson() {
    let json = {
      Name: this.Name,
      NetID: this.NetID,
      TimeElapsed: this.TimeElapsed,
      ClosingIn: this.ClosingIn,
      Duration: this.Duration,
      Players: this.Players,
      Enabled: this.Enabled,
      Opened: this.Opened,
      Type: this.Type,
      DataRef: this.DataRef,
      InitData: this.InitData,
      SequencerAutoOpenNext: this.SequencerAutoOpenNext,
      Parent: this.Parent?.NetID,
      Children: this.Children?.map(c => c.getJson())
    }
    return json
  }


  constructor(jsonActivity, parentActivity=null, meeting = null) {

    Object.assign(this, jsonActivity)

    this.setOpened(jsonActivity.Opened)
    this.TimeLeft = jsonActivity.Duration * 1000 || 0

    this.Parent = parentActivity

    this.meetingRef = meeting

    // au démarrage, on n'a pas toutes les infos pour les players, juste les EnterTime, on update la liste avec les objets de type MeetingPlayers du meeting
    this.handlePlayersListUpdate(Object.keys(this.Players))

    this.Children = this.Children && this.Children.map(child => new Activity(child, this, meeting))

    makeAutoObservable(this)
  }



  customCommand(commandName, additionalParameters = {}) {
    return this.meetingRef.customActivityCommand(commandName, this.NetID, true, additionalParameters)
  }
  get Parent_id() {
    if(this.Parent) return this.Parent.NetID
  }

  get state() {
    if(!this.Enabled) return ACTIVITY_STATES.DISABLED
    if(!this.Opened) return ACTIVITY_STATES.ENABLED
    if(this.Opened) return ACTIVITY_STATES.OPENED
    return ACTIVITY_STATES.FINISHED
  }

  get AllPlayers() {
    // ici il faudrait choper les users de tous les enfants + les miens

    // on récup toutes les ids stock dans Players + children
    let all = {...this.Players}


    if(this.Children) {
      this.Children.forEach(child => {
        all = {...all, ...child.Players}
      })
    }

    return all
  }

  get AllChildrenIds() {
    // utility pour savoir si une activity en contient une autre...
    let ids = []

    if(this.Children) {
      this.Children.forEach(child => {

        ids = [...ids, ...child.AllChildrenIds, child.NetID]
      })
    }

    return ids
  }

  get StopsSequence() {
    return !(this.SequencerAutoOpenNext) || (this.Children && this.Children.at(-1).StopsSequence)
  }

  setEnabled(val) {
    this.Enabled = val

  }
  setOpened(val) {
    this.Opened = val
    if(!val) {
      clearTimeout(this.#timeout)
    }
  }


  #timeOpenedTimeout
  setTimeOpened(t) {
    this.TimeOpened = t
    clearTimeout(this.#timeOpenedTimeout)
    this.#timeOpenedTimeout = setTimeout(_ => this.setTimeOpened(this.TimeOpened + 1000), 1000)
  }
  #timeEnteredTimeout
  setTimeEntered(t) {
    this.TimeEntered = t
    clearTimeout(this.#timeEnteredTimeout)
    this.#timeEnteredTimeout = setTimeout(_ => this.setTimeEntered(this.TimeEntered + 1000), 1000)
  }
  #timeLeftTimeout
  setTimeLeft(t) {
    this.TimeLeft = t
    clearTimeout(this.#timeLeftTimeout)
    this.#timeLeftTimeout = setTimeout(_ => this.setTimeLeft(this.TimeLeft - 1000), 1000)
  }


  handlePlayersListUpdate(playersSesssionIdsArray) {
    // ici on gère
    let newActivityPlayersList = {}

    playersSesssionIdsArray.forEach(s_id => {
      let player = this.Players[s_id]

      // NOTE : on teste player.UserID car au lancement de l'activity, on n'a que les EnterTime (ca vient du serveur), donc si on n'a pas notre objet local MeetingPlayer, on le récupère des données du meeting
      if(player && player.UserID) {
        // on le reprend sans le modifier de l'activity
        newActivityPlayersList[s_id] = player
      }
      else {
        // nouveau joueur dans l'activity, on va le chercher dans les joueurs du meeting
        let player = this.meetingRef.meetingPlayers[s_id]
        if(player) {
          newActivityPlayersList[s_id] = player
        }
        else {
          console.error(`Le joueur avec la session_id ${s_id} est entré dans l'activity ${this.Name}, mais n'a pas été trouvé dans les joueurs du meeting !!!`)
        }
      }
    })

    this.Players = newActivityPlayersList
  }


  // ---- deprecated ?
  #timeout
  setTimeElapsed(t) {
    // console.log(this.Name, "time : ", t)
    this.TimeElapsed = t
    clearTimeout(this.#timeout)
    this.TimeElapsed = this.Duration > 0 ? Math.min(t, this.Duration * 1000) : t
    if(this.Opened) {
      this.#timeout = setTimeout(_ => this.setTimeElapsed(this.TimeElapsed + 1000), 1000)
    }
  }

  #timeout2
  setClosingIn(t) {
    clearTimeout(this.#timeout2)
    this.ClosingIn = Math.max(t, 0)
    if(this.Opened) {
      this.#timeout2 = setTimeout(_ => this.setClosingIn(this.ClosingIn- 1000), 1000)
    }
  }
  // ----
}